import controller from '~/components/bookmark/bookmark.controller';
import template from './bookmark-block.html';

import './bookmark-block.scss';

export default {
	template,
	controller,
	bindings: {
		widgetId: '<',
		isOpen: '=?',
	},
};
